import moment from 'moment';

//this function accepts a start and ned date and will conver it into an array of weeks.
//note: this will include the start of week before the start date and the end of week after the end date.
//eg: if the start date passed is a wednesday, then the Sunday before will be included.
export function getWeeksFromDateRange(startDate, endDate){
    //get the start of the week of the first day specified by the user.
    let weeks = [];
    let computingWeeks = true;
    let weekStart = moment(startDate).startOf('week');
    let weekEnd = moment(startDate).endOf('week');

    weeks.push({
        startOfWeek: weekStart,
        endOfWeek: weekEnd
    })

    //check to see if the end of the week is after the end date specified by the user.
    //if it is, then we are done, we have covered all of the weeks.
    //if not, then we need to do the same thing until it is.
    while(computingWeeks){
        if(moment(weekEnd).isSameOrAfter(endDate)){
            //we have covered all the days.
            computingWeeks = false;
        }else{
            //keep goin, bud.
            weekStart = moment(weekEnd).add('days', 1);
            weekEnd = moment(weekStart).endOf('week');

            weeks.push({
                startOfWeek: weekStart,
                endOfWeek: weekEnd
            })
        }
    }

    return weeks;
}